exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tab-content{background:#fff;padding:20px}table{width:100%}table th{font-weight:900}table td,table th{padding:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-024b86c8!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/allegroAnalysis/AllegroAnalysisDetail.vue
// module id = 834
// module chunks = 2